// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bOIj","comment":"styles_comment__2KAKb"};